import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { RiMenuLine, RiCloseLine, RiArrowDownSLine, RiArrowRightSLine } from "react-icons/ri";
import './navbar.css';
import logo from '../../assets/IB_logo.png';
import { UserAuth } from "../../context/Authcontext";
import { db } from "../../firebase";
import { doc, getDoc, getDocs, query, collection, where } from "firebase/firestore";

const Navbar = () => {
  const { logOut, user, memberIndex, setMemberIndex } = UserAuth();
  const [userData, setUserData] = useState([]);
  const [adminData, setAdminData] = useState(null);
  
  // Navigation & Scroll State
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [hidden, setHidden] = useState(false);

  // Scroll Behavior
  useEffect(() => {
    let lastScrollY = window.scrollY || document.documentElement.scrollTop;

    const handleScroll = () => {
      const currentScrollY = window.scrollY || document.documentElement.scrollTop;

      // Add box shadow when scrolled past 15px
      setScrolled(currentScrollY > 15);

      // Hide when scrolling down past 80px, show when scrolling up
      if (currentScrollY > 80 && currentScrollY > lastScrollY) {
        setHidden(true);
      } else {
        setHidden(false);
      }

      lastScrollY = currentScrollY;
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleSignOut = async () => {
    try {
      await logOut();
      setMobileMenuOpen(false);
    } catch (error) {
      console.log(error);
    }
  };

  const handleMemberSwitch = (index) => {
    setMemberIndex(index);
  };

  useEffect(() => {
    const getAdminData = async () => {
      setAdminData(null);
      const ref = doc(db, "app_admin", user.email);
      try {
        const docSnap = await getDoc(ref);
        if (docSnap.exists() && docSnap.data()) {
          setAdminData(docSnap.data());
        }
      } catch (error) {
        console.log(error);
      }
    };

    const getUserData = async () => {
      setUserData([]);
      const q = query(collection(db, "users"), where("email", "==", user.email));
      let tempUserData = [];

      try {
        const docSnap = await getDocs(q);
        docSnap.forEach((doc) => {
          tempUserData.push(doc.data());
        });
        setUserData(tempUserData);
      } catch (error) {
        console.log(error);
      }
    };

    if (user && user.email) {
      getUserData();
      getAdminData();
    }
  }, [user]);

  const closeMenus = () => {
    setActiveDropdown(null);
    setMobileMenuOpen(false);
  };

  return (
    <>
      {/* Invisible Hover Zone */}
      <div 
        className="navbar_hover_zone" 
        onMouseEnter={() => setHidden(false)} 
      />

      <header 
        className={`navbar_wrapper ${scrolled ? 'navbar-scrolled' : ''} ${hidden ? 'navbar-hidden' : ''}`}
        onMouseEnter={() => setHidden(false)}
      >
        <div className="navbar_inner">
          
          {/* Mobile Toggle */}
          <button 
            className="navbar_mobile_toggle" 
            onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
            aria-label="Toggle navigation menu"
          >
            {mobileMenuOpen ? <RiCloseLine size={26} /> : <RiMenuLine size={26} />}
          </button>

          {/* Logo */}
          <div className="navbar_logo">
            <Link to="/" onClick={closeMenus}>
              <img src={logo} alt="International Buddy Logo" />
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="navbar_nav_desktop">
            
            {/* About */}
            <div 
              className="navbar_dropdown_item"
              onMouseEnter={() => setActiveDropdown('about')}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <button className="navbar_link_btn">
                About <RiArrowDownSLine className={`dropdown_chevron ${activeDropdown === 'about' ? 'open' : ''}`} />
              </button>
              <div className={`navbar_menu_popup ${activeDropdown === 'about' ? 'visible' : ''}`}>
                <Link to="/whatwedo" onClick={closeMenus}>About Us <RiArrowRightSLine /></Link>
                <Link to="/ourteam" onClick={closeMenus}>Our Leaders <RiArrowRightSLine /></Link>
                <Link to="/volunteerawards" onClick={closeMenus}>Volunteer Awards<RiArrowRightSLine /></Link>
                <Link to="/chiefprogrammentor" onClick={closeMenus}>Chief Program Mentor<RiArrowRightSLine /></Link>
                <Link to="/pastevents" onClick={closeMenus}>News <RiArrowRightSLine /></Link>
                <Link to="/history" onClick={closeMenus}>History <RiArrowRightSLine /></Link>
                <Link to="/contact" onClick={closeMenus}>Contact <RiArrowRightSLine /></Link>
              </div>
            </div>

            {/* Attend */}
            <div 
              className="navbar_dropdown_item"
              onMouseEnter={() => setActiveDropdown('attend')}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <button className="navbar_link_btn">
                Attend <RiArrowDownSLine className={`dropdown_chevron ${activeDropdown === 'attend' ? 'open' : ''}`} />
              </button>
              <div className={`navbar_menu_popup ${activeDropdown === 'attend' ? 'visible' : ''}`}>
                <Link to="/weekly" onClick={closeMenus}>Weekly Activities <RiArrowRightSLine /></Link>
                <Link to="/specialevents" onClick={closeMenus}>Special Events <RiArrowRightSLine /></Link>
                <Link to="/specialolympics" onClick={closeMenus}>Special Olympics <RiArrowRightSLine /></Link>
                <Link to="/upcomingevents" onClick={closeMenus}>Upcoming Events <RiArrowRightSLine /></Link>
              </div>
            </div>

            {/* Contribute */}
            <div 
              className="navbar_dropdown_item"
              onMouseEnter={() => setActiveDropdown('contribute')}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <button className="navbar_link_btn">
                Contribute <RiArrowDownSLine className={`dropdown_chevron ${activeDropdown === 'contribute' ? 'open' : ''}`} />
              </button>
              <div className={`navbar_menu_popup ${activeDropdown === 'contribute' ? 'visible' : ''}`}>
                <Link to="/volunteer" onClick={closeMenus}>Volunteer <RiArrowRightSLine /></Link>
                <Link to="/donate" onClick={closeMenus}>Donate <RiArrowRightSLine /></Link>
                <Link to="/artgallery" onClick={closeMenus}>Art Gallery <RiArrowRightSLine /></Link>
              </div>
            </div>

            {/* Resource */}
            <div 
              className="navbar_dropdown_item"
              onMouseEnter={() => setActiveDropdown('resource')}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <button className="navbar_link_btn">
                Resources <RiArrowDownSLine className={`dropdown_chevron ${activeDropdown === 'resource' ? 'open' : ''}`} />
              </button>
              <div className={`navbar_menu_popup ${activeDropdown === 'resource' ? 'visible' : ''}`}>
                <Link to="/documents" onClick={closeMenus}>Related Documents <RiArrowRightSLine /></Link>
                <Link to="/training" onClick={closeMenus}>Volunteer Training <RiArrowRightSLine /></Link>
                <a 
                  href="https://firebasestorage.googleapis.com/v0/b/internationalbuddy2018.appspot.com/o/manual%2FIB%20Web%20Quick%20Manual.pdf?alt=media&token=e727a1b4-4081-4927-a2a4-6bad6bd6c60d" 
                  target="_blank" 
                  rel="noopener noreferrer"
                >
                  Website Quick Manual <RiArrowRightSLine />
                </a>
              </div>
            </div>

            {/* Account (Desktop) */}
            <div 
              className="navbar_dropdown_item"
              onMouseEnter={() => setActiveDropdown('user')}
              onMouseLeave={() => setActiveDropdown(null)}
            >
              <button className="navbar_link_btn user_btn">
                Account <RiArrowDownSLine className={`dropdown_chevron ${activeDropdown === 'user' ? 'open' : ''}`} />
              </button>
              <div className={`navbar_menu_popup ${activeDropdown === 'user' ? 'visible' : ''}`}>
                {user?.email ? (
                  <>
                    {adminData?.role === "admin" && (
                      <Link to="/ibadmin" onClick={closeMenus}>Admin Page <RiArrowRightSLine /></Link>
                    )}
                    <Link to="/profile" onClick={closeMenus}>Profile <RiArrowRightSLine /></Link>
                    {!(user.email.match(/gmail.com/gi)) && (
                      <Link to="/changepassword" onClick={closeMenus}>Change Password <RiArrowRightSLine /></Link>
                    )}
                    {userData[memberIndex]?.role === "Volunteer" && (
                      <Link to="/servicehours" onClick={closeMenus}>Service Hours <RiArrowRightSLine /></Link>
                    )}
                    
                    {/* Member Switcher */}
                    {userData.length > 0 && (
                      <div className="member_switcher_box">
                        <span className="member_switcher_label">Select Profile:</span>
                        {userData.map((userDoc, key) => (
                          <button
                            key={key}
                            className={`member_pill ${key === memberIndex ? 'active' : ''}`}
                            onClick={() => handleMemberSwitch(key)}
                          >
                            {userDoc.name}
                          </button>
                        ))}
                      </div>
                    )}

                    <div className="dropdown_divider" />
                    <button className="navbar_signout_btn" onClick={handleSignOut}>Sign Out</button>
                  </>
                ) : (
                  <Link to="/login" onClick={closeMenus} className="dropdown_action_link">Sign In</Link>
                )}
              </div>
            </div>

          </nav>

          {/* Action Button Right */}
          <div className="navbar_actions">
            {user?.email ? (
              <button className="nav_pill_btn signout" onClick={handleSignOut}>Sign Out</button>
            ) : (
              <Link to="/login">
                <button className="nav_pill_btn signin">Sign In</button>
              </Link>
            )}
          </div>

        </div>

        {/* Mobile Drawer */}
        <div className={`mobile_drawer ${mobileMenuOpen ? 'open' : ''}`}>
          <div className="mobile_drawer_content">
            <div className="mobile_section">
              <h4>About</h4>
              <Link to="/whatwedo" onClick={closeMenus}>About Us</Link>
              <Link to="/ourteam" onClick={closeMenus}>Our Leaders</Link>
              <Link to="/volunteerawards" onClick={closeMenus}>Volunteer Awards</Link>
              <Link to="/chiefprogrammentor" onClick={closeMenus}>Chief Program Mentor</Link>
              <Link to="/pastevents" onClick={closeMenus}>News</Link>
              <Link to="/history" onClick={closeMenus}>History</Link>
              <Link to="/contact" onClick={closeMenus}>Contact</Link>
            </div>

            <div className="mobile_section">
              <h4>Attend</h4>
              <Link to="/weekly" onClick={closeMenus}>Weekly Activities</Link>
              <Link to="/specialevents" onClick={closeMenus}>Past Special Events</Link>
              <Link to="/specialolympics" onClick={closeMenus}>Special Olympics</Link>
              <Link to="/upcomingevents" onClick={closeMenus}>Upcoming Events</Link>
            </div>

            <div className="mobile_section">
              <h4>Contribute</h4>
              <Link to="/volunteer" onClick={closeMenus}>Volunteer</Link>
              <Link to="/donate" onClick={closeMenus}>Donate</Link>
              <Link to="/artgallery" onClick={closeMenus}>Art Gallery</Link>
            </div>

            <div className="mobile_section">
              <h4>Resource</h4>
              <Link to="/documents" onClick={closeMenus}>Related Documents</Link>
              <Link to="/training" onClick={closeMenus}>Volunteer Training</Link>
              <a 
                href="https://firebasestorage.googleapis.com/v0/b/internationalbuddy2018.appspot.com/o/manual%2FIB%20Web%20Quick%20Manual.pdf?alt=media&token=e727a1b4-4081-4927-a2a4-6bad6bd6c60d" 
                target="_blank" 
                rel="noopener noreferrer"
              >
                Website Quick Manual
              </a>
            </div>

            {/* Mobile Account Section with Full Logic */}
            {user?.email ? (
              <div className="mobile_section user_mobile">
                <h4>Account</h4>
                {adminData?.role === "admin" && (
                  <Link to="/ibadmin" onClick={closeMenus}>Admin Page</Link>
                )}
                <Link to="/profile" onClick={closeMenus}>Profile</Link>
                {!(user.email.match(/gmail.com/gi)) && (
                  <Link to="/changepassword" onClick={closeMenus}>Change Password</Link>
                )}
                {userData[memberIndex]?.role === "Volunteer" && (
                  <Link to="/servicehours" onClick={closeMenus}>Service Hours</Link>
                )}

                {/* Member Switcher for Mobile */}
                {userData.length > 0 && (
                  <div className="member_switcher_box" style={{ marginTop: '10px' }}>
                    <span className="member_switcher_label">Select Profile:</span>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: '6px', marginTop: '6px' }}>
                      {userData.map((userDoc, key) => (
                        <button
                          key={key}
                          className={`member_pill ${key === memberIndex ? 'active' : ''}`}
                          onClick={() => handleMemberSwitch(key)}
                        >
                          {userDoc.name}
                        </button>
                      ))}
                    </div>
                  </div>
                )}

                <button 
                  className="nav_pill_btn signout full_width" 
                  onClick={handleSignOut} 
                  style={{ marginTop: '15px' }}
                >
                  Sign Out
                </button>
              </div>
            ) : (
              <div className="mobile_section user_mobile">
                <Link to="/login" onClick={closeMenus}>
                  <button className="nav_pill_btn signin full_width">Sign In</button>
                </Link>
              </div>
            )}
          </div>
        </div>
      </header>
    </>
  );
};

export default Navbar;